module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/13845e22946385773258430cbb9f7b1a.png";